import PropTypes from 'prop-types'
import { Clock } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { getReservationDurationLimits } from './helper'

const BookingDurationLimits = ({ amenity }) => {
  const { t } = useTranslation(['reservations'])
  const limits = getReservationDurationLimits(amenity, t)

  if (!limits) return null

  const rows = [
    { label: t('reservations:bookingDurationLimits.minDuration'), value: limits.min },
    { label: t('reservations:bookingDurationLimits.maxDuration'), value: limits.max },
  ]

  return (
    <div className="booking-duration-limits">
      {rows.map(({ label, value }) => (
        <div className="booking-duration-limits__row" key={label}>
          <span className="booking-duration-limits__label">
            <Clock size={20} />
            {label}
          </span>
          <span className="booking-duration-limits__value">{value}</span>
        </div>
      ))}
    </div>
  )
}

BookingDurationLimits.propTypes = {
  amenity: PropTypes.object,
}

export default BookingDurationLimits
